import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m11.445 17.305-.588.41.207-.686-.57-.433.716-.014.235-.677.235.677.716.014-.57.433.207.685zm.615-2.346-.587.409.207-.686-.57-.432.715-.015.235-.676.236.676.716.015-.571.432.207.686zm1.63-1.758-.588.409.208-.685-.57-.433.715-.015.235-.676.235.676.716.015-.57.433.207.685zm2.311-.595-.587.41.207-.686-.57-.433.715-.014.235-.677.235.677.716.014-.57.433.207.685zm2.191.63-.588.409.207-.685-.57-.433.716-.015.235-.676.235.676.716.015-.57.433.207.685zm1.605 1.722-.588.41.208-.686-.57-.433.715-.014.235-.677.235.677.716.014-.57.433.207.685zm.623 2.382-.587.41.207-.686-.57-.433.716-.014.235-.677.235.677.716.014-.57.433.207.686z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M13.14 20.636A6.7 6.7 0 0 1 16 20a6.8 6.8 0 0 1 2.861.636.333.333 0 1 0 .278-.606A7.5 7.5 0 0 0 16 19.333a7.4 7.4 0 0 0-3.14.698.333.333 0 0 0 .279.605M16 18.082c.589.4 1.213.509 1.91.248.517.546 1.176.653 1.901.304a.333.333 0 0 0-.289-.601c-.52.25-.902.157-1.25-.306a.33.33 0 0 0-.412-.1c-.627.303-1.121.207-1.65-.22a.33.33 0 0 0-.42 0c-.528.427-1.022.523-1.65.22a.334.334 0 0 0-.412.1c-.347.463-.73.557-1.25.306a.333.333 0 1 0-.29.6c.726.35 1.385.242 1.903-.302.696.26 1.32.15 1.91-.25"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M15.667 15.09a.66.66 0 0 0-.663-.003L15 15a1 1 0 1 1 1.996.087.66.66 0 0 0-.663.002V18h-.666z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagTjk = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagTjk_default = SvgFlagTjk;

export { FlagTjk_default as default };
